import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { AccountService } from "../services/account.service";
import { DatePipe } from "@angular/common";



@Injectable()
export class AccountDataResolve implements Resolve<any> {

    constructor(private accService: AccountService) {
        
    }
    
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        switch (state.url) {
            case '/':
            case '/home':
                break;
            case '/profile':
                return new Promise<any>((resolve, reject) => {
                    this.accService.getProfile().subscribe(
                        (data) => {
                            resolve(data);
                        });
                }).then(function (data) {
                    return data;
                });

            default:
                break;
        }
    }

}
